module.exports = __webpack_public_path__ + "img/18_94.6f332ba6.png";